<template>
  <common-modal
    :name="name"
    :title="title"
    :hideFooter="true"
    height="320px"
    width="800px"
  >
    <template #modal-body>
      <validation-form @on-submit="updateActivity">
        <md-card class="my-0">
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.name"
                  name="name"
                >
                  <label>{{ $t("class.activity_name") }}</label>
                  <md-input v-model.trim="form.name" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.name }}</span
                  >
                </validation-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label :for="select.name">{{ $t(select.label) }} </label>
                  <md-select
                    required
                    v-model="form.categoryId"
                    :name="select.name"
                    :id="select.name"
                    :multiple="select.multiple"
                  >
                    <md-option
                      v-for="option in select.options"
                      :value="option.id"
                      :key="option.id + option.name"
                      >{{ option.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.maxPoint"
                  name="max point"
                >
                  <label> {{ $t("class.max_point") }} </label>
                  <md-input v-model="form.maxPoint" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.max_point }}</span
                  >
                </validation-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <div class=" form-actions text-right pt-3 pb-3">
          <div class="md-layout">
            <div class="md-layout-item md-size-50"></div>
            <div class="md-layout-item md-size-50">
              <md-card
                class="detail-sis tooltip"
                :class="{ hidden: !tooltipActive }"
                v-click-outside="closeCardConfirmDelete"
              >
                <div class="md-layout">
                  <div class="md-layout-item md-side-100 pt-4">
                    {{
                      $t("class.are_you_sure_you_want_to_delete_this_activity")
                    }}
                  </div>
                  <div class="md-layout-item md-size-100">
                    <a
                      @click="deleteActivity"
                      class="pr-5 text-red-500 cursor-pointer"
                      >{{ $t("common.yes") }}</a
                    >
                    <a
                      @click="closeCardConfirmDelete"
                      class="pl-5 text-green-500 cursor-pointer"
                      >{{ $t("common.no") }}</a
                    >
                  </div>
                </div>
              </md-card>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-button class="md-raised mr-3" @click="closeModal">{{
                $t("common.cancel")
              }}</md-button>
              <md-button
                v-if="isDeleteActivity"
                class="md-raised md-danger mr-3"
                @click="confirmDeleteActivity"
                >{{ $t("common.delete") }}</md-button
              >
              <md-button type="submit" class="md-success mr-3">{{
                $t("common.update")
              }}</md-button>
            </div>
          </div>
        </div>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { parameterValidations } from "@/validations/classes";
import { service_names, service_paths } from "@/constants/Services";
import { genErrMsgOj, Message } from "@/helpers/utils";
import { Class } from "@/constants/Permissions";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";

export default {
  components: { CommonModal },
  props: [
    "name",
    "title",
    "isDisableAction",
    "dataDetail",
    "defaultData",
    "scoreList"
  ],
  inject: ["getScores"],
  data() {
    const classId = this.$route.params.id;
    return {
      pathGetCategories: `${service_paths.class_activity_categories}/class/${classId}`,
      path: `${service_names.school}/class-activities/activities/class/${classId}`,
      form: this.dataDetail,
      serverValidations: {},
      classValidation: parameterValidations,
      select: {
        label: "class.category",
        name: "status__",
        value: "",
        type: "select",
        options: []
      },
      tooltipActive: false,
      isConfirmClick: false,
      Class
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    isDeleteActivity() {
      return (
        this.$can(Class.actions.delete, Class.subject) ||
        hasValidRole(this.userRole, Role.Teacher)
      );
    }
  },
  created() {
    this.getParameters();
  },
  watch: {
    "form.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "form.max_point": function() {
      this.serverValidations.max_point &&
        delete this.serverValidations.max_point;
    }
  },
  methods: {
    closeCardConfirmDelete() {
      if (this.isConfirmClick) {
        this.isConfirmClick = false;
        return;
      }
      this.tooltipActive = false;
    },
    getCurrentMaxScore() {
      const scoreList = this.scoreList;
      let arrScore = [];
      scoreList.map(item => {
        item.categories.map(category => {
          category.activities.map(activity => {
            if (
              activity.category_id === this.form.categoryId &&
              activity.name === this.defaultData.name
            ) {
              arrScore.push(parseFloat(activity.default_score));
            }
          });
        });
      });
      return Math.max(...arrScore);
    },
    updateActivity() {
      const currentMaxScore = this.getCurrentMaxScore();
      if (parseFloat(this.form.maxPoint) < parseFloat(currentMaxScore)) {
        Message.error(this.$t("class.the_max_point_must_be_greater"));
        return;
      }
      const form = {
        name: this.defaultData.name,
        name_update: this.form.name,
        category_id: this.defaultData.categoryId,
        category_id_update: this.form.categoryId,
        max_point: this.form.maxPoint
      };
      this.$axios
        .put(this.path, form)
        .then(() => {
          Message.success(this.$t("common.edit_success"));
          this.getScores();
          this.closeModal();
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    confirmDeleteActivity() {
      this.isConfirmClick = true;
      this.tooltipActive = !this.tooltipActive;
    },
    deleteActivity() {
      const form = {
        name: this.defaultData.name,
        category_id: this.defaultData.categoryId
      };
      this.$axios.delete(this.path, form).then(() => {
        Message.success(this.$t("common.delete_success"));
        this.getScores();
        this.closeModal();
      });
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
    getParameters() {
      return this.$axios
        .get(
          this.pathGetCategories,
          { undefined },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          if (response.data) {
            this.select.options = response.data.map(item => {
              return { name: item.name, id: item.id };
            });
          }
        });
    }
  }
};
</script>

<style lang="scss">
.detail-sis.tooltip {
  position: absolute;
  top: 90px;
  z-index: 4;
  width: 215px;
  height: 125px;
  left: 480px;
  text-align: center;
  background: #f1e8dc;
  box-shadow: gray;
  border-radius: 20px;
}
</style>
